import PageableBase from 'app/collections/pageable_base';
import { appUrl } from 'utils/wrappers';
import PaymentLog from 'app/models/payment_log';

export default PageableBase.extend({
  model: PaymentLog,
  key: 'payment_logs',
  url: appUrl('payment_logs'),

  initialize(models, { paymentMethods }) {
    this.paymentMethods = paymentMethods;
    this.listenTo(this.paymentMethods, 'charge', this.resetToFirstPage);
  },
});



// WEBPACK FOOTER //
// ./app/collections/payment_logs.js